import { render, staticRenderFns } from "./gotoTop.vue?vue&type=template&id=1f8d07fa&scoped=true"
import script from "./gotoTop.vue?vue&type=script&lang=js"
export * from "./gotoTop.vue?vue&type=script&lang=js"
import style0 from "./gotoTop.vue?vue&type=style&index=0&id=1f8d07fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d07fa",
  null
  
)

export default component.exports